import { useState } from 'react';
import { useInterval } from 'usehooks-ts';

export function useAutoRefreshedValue<T>(update: () => T, milliseconds: number): T {
  const [lastValue, setLastValue] = useState<T>(update);

  useInterval(() => {
    setLastValue(update());
  }, milliseconds);

  return lastValue;
}
